import React from 'react';
import PageBackground from '../../components/Layouts/PageBackground';
import { socialfeatures } from '../../data';
import './Features.css';

const Features = () => {
  return (      
      <PageBackground
        title="FEATURES"
      >
        <div className="social-container">
        {socialfeatures.map((features, i) => 
            <div className="flip-card" key={features.title + i}>
              <div className="flip-card-inner">
                <div className="flip-card-front" style={{background: `black url(${features.image})`}}>
                  <div className="flip-card-content">
                    {features.title}
                  </div>
                </div>
                <div className="flip-card-back" style={{background: `black url(${features.image})`}}>
                  <div className="flip-card-content">
                    {features.description}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </PageBackground>
  );
};

export default Features;
